<div class="container z-10">
  <div class="flex items-center justify-center gap-4">
    <button
      type="button"
      class="mt-4 py-3 px-4 font-semibold rounded-sm text-gray border-2 border-gray-500 bg-red-200 hover:border-gray-200 hover:text-white hover:bg-gray-500 z-10"
      (click)="loadLocations()"
    >
      Load location
    </button>
    <div class="flex flex-col">
      <label for="">
        <p>Start Date</p>
      </label>
      <input type="datetime-local" [(ngModel)]="startDateInput" />
    </div>
    <div class="flex flex-col">
      <label for="">
        <p>End Date</p>
      </label>
      <input type="datetime-local" [(ngModel)]="endDateInput" />
    </div>
    <div class="flex items-center gap-2">
      <button
        type="button"
        class="mt-4 py-3 px-4 font-semibold rounded-sm border text-gray border-none bg-red-200 hover:border-gray-200 hover:text-white hover:bg-gray-500 z-10"
        (click)="downloadLocations()"
      >
        Download Location
        <i class="ti ti-download"></i>
      </button>
    </div>
  </div>

  <div class="flex gap-4 mt-4">
    <app-location-list (locationsChange)="locations = $event" />
    <app-location-map [locations]="locations" />
  </div>
</div>
